import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiUrl } from "../apiUrl";

export const getOdontogramas = createAsyncThunk(
    "odontogramas/getOdontogramas",
    async () => {
        const { data } = await axios.get(`${apiUrl}/api/v1/odontogramas`);
        return data;
    }
)

export const getOdontogramaByCitaId = createAsyncThunk(
    "odontogramas/getEstudiosByCitaId",
    async (idCita) => {
      const { data } = await axios.get(
        `${apiUrl}/api/v1/odontogramas/cita/${idCita}`
      );
      return data;
    }
  );

export const createOdontograma = createAsyncThunk(
    "odontogramas/createOdontograma",
    async (body) => {
        const fd = new FormData();
        for (const key in body) {
            const value = body[key];
            if (value !== undefined && value !== null) {
                fd.append(key, value);
            }
        }
        const { data } = await axios.post(`${apiUrl}/api/v1/odontogramas`, fd);
        return data;
    }
)

export const getHistorialOdontogramaByPatientId = createAsyncThunk(
    "odontogramas/getHistorialByPatientId",
    async (patientId) => {
        const { data } = await axios.get(`${apiUrl}/api/v1/odontogramas/paciente/${patientId}`);
        return data;
    }
)

export const deleteOdontograma = createAsyncThunk(
    "odontogramas/deleteOdontograma",
    async (id) => {
        const { data } = await axios.delete(`${apiUrl}/api/v1/odontogramas/${id}`);
        return data;
    }
)

const initialState = {
    status: "idle",
    odontogramas: [],
    odontogramasCita: [],
    historialPaciente: [],
    historialPatientId: null,
    loading: false,
    error: null,
}

export const odontogramaSlice = createSlice({
    name: "odontograma",
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getOdontogramas.pending, (state) => {
                state.loading = true
            })
            .addCase(getOdontogramas.fulfilled, (state, action) => {
                state.loading = false
                state.odontogramas = action.payload
            })
            .addCase(getOdontogramas.rejected, (state) => {
                state.loading = false
            })
            .addCase(getOdontogramaByCitaId.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getOdontogramaByCitaId.fulfilled, (state, action) => {
                state.status = "succeed";
                state.odontogramasCita = action.payload;
            })
            .addCase(getOdontogramaByCitaId.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            })
            .addCase(getHistorialOdontogramaByPatientId.pending, (state) => {
                state.status = "loading";
            })
            .addCase(getHistorialOdontogramaByPatientId.fulfilled, (state, action) => {
                state.status = "succeed";
                state.historialPaciente = action.payload;
                state.historialPatientId = action.meta.arg;
            })
            .addCase(getHistorialOdontogramaByPatientId.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            })
    }
})

export const getAllOdontogramas = (state) => state.odontograma.odontogramas;
export const getAllOdontogramaByCita = (state) => state.odontograma.odontogramasCita;
export const getHistorialOdontograma = (state) => state.odontograma.historialPaciente;
export const getHistorialPatientId = (state) => state.odontograma.historialPatientId;
export const getOdontogramasError = (state) => state.odontograma.error;

export default odontogramaSlice.reducer;
